export default "__VITE_ASSET__DgIwis04__"